import parse from "html-react-parser";

type ShippingNoticeProps = {
  tr_shipping_message: string;
  shipping_threshold: number;
  shipping_start_value?: number;
};

export const ShippingNotice = ({
  tr_shipping_message,
  shipping_threshold,
  shipping_start_value = 0,
}: ShippingNoticeProps) => {
  const message = tr_shipping_message.replace(
    /###threshold###/g,
    `<strong>$${shipping_threshold - shipping_start_value}</strong>`,
  );
  return (
    <div className="shipping-notice">
      <div className="shipping-text">{parse(message)}</div>
      <div className="shipping-progress">
        <span className="progress-label-start">${shipping_start_value}</span>
        <div className="progress-track">
          <div className="progress-fill-shipping"></div>
        </div>
        <span className="progress-label-end">${shipping_threshold}</span>
      </div>
    </div>
  );
};
